import React, { createContext, useContext, useState, useEffect } from 'react';
import WebApp from "@twa-dev/sdk";
import { lightTheme, darkTheme } from '../themes';

const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
	const [currentTheme, setCurrentTheme] = useState(() => {
		// Проверяем сохраненную тему
		const savedTheme = localStorage.getItem('app_theme');
		if (savedTheme) {
			return savedTheme === 'dark' ? darkTheme : lightTheme;
		}

		// Проверяем тему из Telegram WebApp
		if (WebApp.platform !== 'unknown') {
			return WebApp.colorScheme === 'dark' ? darkTheme : lightTheme;
		}

		// По умолчанию используем тёмную тему
		return darkTheme;
	});

	useEffect(() => {
		if (WebApp.platform !== 'unknown') {
			const handleThemeChange = () => {
				const newTheme = WebApp.colorScheme === 'dark' ? darkTheme : lightTheme;
				setCurrentTheme(newTheme);
				localStorage.setItem('app_theme', WebApp.colorScheme);
			};

			WebApp.onEvent('themeChanged', handleThemeChange);

			return () => {
				WebApp.offEvent('themeChanged', handleThemeChange);
			};
		}
	}, []);

	const toggleTheme = () => {
		const newTheme = currentTheme === darkTheme ? lightTheme : darkTheme;
		setCurrentTheme(newTheme);
		localStorage.setItem('app_theme', newTheme === darkTheme ? 'dark' : 'light');
	};

	const value = {
		currentTheme,
		toggleTheme,
		isDarkTheme: currentTheme === darkTheme
	};

	return (
		<ThemeContext.Provider value={value}>
			{children}
		</ThemeContext.Provider>
	);
};

const useThemeContext = () => {
	const context = useContext(ThemeContext);
	if (!context) {
		throw new Error('useThemeContext must be used within a ThemeProvider');
	}
	return context;
};

export { ThemeProvider, useThemeContext };
export default ThemeContext; 